import React from 'react'
import Message from './Message'

/* doc
---
title: ErrorMessage
name: ErrorMessage
category: React - Bulma
parent: Message
---

An `ErrorMessage` component applies the `.is-danger` class to the `Message` component.

Use this component to display an error to the user.

See the `Message` documentation for further information.

```html_example
  <ErrorMessage>
    <MessageHeader>...</MessageHeader>
    <MessageBody>
      ...
    </MessageBody>
  </ErrorMessage>
```
*/
function ErrorMessage(props) {
  const { className, children, ...rest } = props

  const classes = [
    'is-danger',
    className || '',
  ]

  return (
    <Message {...rest} className={classes.join(' ')}>
      {children}
    </Message>
  )
}

export default ErrorMessage
